module.exports = __webpack_public_path__ + "img/PPMPRA10.8da96935.png";